import {useState}  from 'react';
import {useRef}  from 'react';
import {toast} from 'react-toastify';
import { useDispatch } from 'react-redux';
import { addPost } from './redux/chatSlice';
import './App.css';
function Tweet({closeModal}){
const [ShowTweetDialog,setShowTweetDialog]=useState(true);
const [text,setText]=useState('');
const [preview,setPreview]=useState(null);
const[image,setImage]=useState(null);
const handlefile=useRef(null);
//dispatch tweet
const dispatch = useDispatch();

//acess to open the hidden file
    function handleclick(){
      if(handlefile.current){
   handlefile.current.click();
    }
   };
    const handletouch=(e)=>{
    const file=e.target.files[0];
    //comes out from input
     if(file.size > 2 * 1024*1024){
      alert('Image must be less than 2MB')
    }
    if(!file) return;
   setImage(file);

   setPreview(URL.createObjectURL(file));
   console.log('preview URL:',URL.createObjectURL(file))
    };
const handlepost=()=>{
if(!text && !image) {
       toast.warning('Write Something');
       return;
}
    toast.success('Tweet posted successfully')
dispatch(addPost({
    username:'Sam',
    text: text,
    image:preview
}))
//simulate network delay
setTimeout(()=>{
   setText('');
   setPreview(null);
   setImage(null);
   closeModal();
},600);
};
    return(
        <div >
            {ShowTweetDialog && ( 
    <div className='overlay'>
   <div className='glass-pop' >
   <h4  className=' tweet-modal'style={{fontFamily:'helvetica',padding:'2px'}} >New Tweet</h4>
   <div className='tweetdialog1' style={{border: '1px solid lightgrey',padding:'20px' }}>
   <textarea type='text'placeholder='Reminds me of'className='tweet'style={{padding:'17px',outline:'none',border:'4px solid lightblue',minWidth:'100px',width:'100%' }} value={text}onChange={(e)=>setText(e.target.value)}/>
   <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRw8ntX-pL8zIL1uk_aUa4Nxbjz_PvwBKxUxQ&s' className='p-2'alt='img'style={{width:'45px'}}onClick={handleclick}/>
   <input type='file' accept='image/*' ref={handlefile} style={{display:'none',padding:'2px'}}onChange={handletouch}/>
  {preview &&(
   <img src={preview} alt='preview' className='image-preview' style={{maxWidth:'100%',maxHeight:'200px',objectFit:'cover'}}/>
)}
 </div>
   <div className='d-flex' style={{paddingLeft:'400px' ,width:'100%',margin:'10px',gap:'20px'}}>
   <button className='btn btn-primary'  onClick={handlepost}>Post</button>
   <button className='btn btn-warning' onClick={closeModal}>Close</button>
   </div>
        </div>

   </div>
)}
        </div>
    )
}
export default Tweet;
